import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./card_entry_method.js";
//#region src/card_entry_method_helper.ts
var card_entry_method_helper_exports = /* @__PURE__ */ __exportAll({
	name: () => name,
	stringFromEnum: () => stringFromEnum
});
function name(cardEntryMethod) {
	switch (cardEntryMethod) {
		case 0: return "Unknown";
		case 1: return "Swipe";
		case 2: return "EMV";
		case 3: return "Contactless";
		case 4: return "Manually Entered";
		case 5: return "Scan";
		case 6: return "Apple Pay";
		case 7: return "Google Pay";
		case 8: return "Provided Externally";
		case 9: return "Card on File";
	}
}
function stringFromEnum(cardEntryMethod) {
	switch (cardEntryMethod) {
		case 0: return "unknown";
		case 1: return "swipe";
		case 2: return "emv";
		case 3: return "contactless";
		case 4: return "manually-entered";
		case 5: return "scan";
		case 6: return "apple-pay";
		case 7: return "google-pay";
		case 8: return "provided-externally";
		case 9: return "card-on-file";
	}
}
//#endregion
export { card_entry_method_helper_exports, name, stringFromEnum };

//# sourceMappingURL=card_entry_method_helper.js.map